module.exports = __webpack_public_path__ + "static/img/cucc.320cd19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cucc.png
// module id = urjg
// module chunks = 40